import { FormControl, FormHelperText, InputLabel, Select, SelectProps as MuiSelectProps } from "@mui/material";
import { useFormikContext } from "formik";
import { forwardRef, useMemo } from "react";
import { FC, Ref } from "react";
import { hEncode } from "~/utils/hashid";

export type SelectProps = MuiSelectProps & {
  label: string;
  name: string;
  ref: Ref<any>;
}

const SelectField = forwardRef<any, SelectProps>((props, ref) => {
  const {
    label,
    name,
    fullWidth,
    ...rest
  } = props
  const {
    touched,
    errors,
    values,
    handleBlur,
    handleChange
  } = useFormikContext<any>()

  const uid = useMemo(() => name + '-' + hEncode(new Date().getMilliseconds()), [name])

  return (
    <FormControl fullWidth error={Boolean(touched[name] && errors[name])}>
      <InputLabel htmlFor={uid} id={`${uid}-label`}>{label}</InputLabel>
      <Select 
        id={uid}
        aria-labelledby={`${uid}-label`}
        aria-describedby={Boolean(touched[name] && errors[name]) ? `${uid}-helper-text` : undefined}
        error={Boolean(touched[name] && errors[name])} 
        fullWidth
        label={label}
        labelId={`${uid}-label`}
        name={name}
        onBlur={handleBlur}
        onChange={handleChange}
        value={values[name]}
        {...{ref}}
        {...rest}
        inputProps={{
          ...(rest.inputProps),
          label,
        }}
      />
      {Boolean(touched[name] && errors[name]) && <FormHelperText id={`${uid}-helper-text`}>{touched[name] && errors[name]}</FormHelperText>}
    </FormControl>
  )
})

export default SelectField;
